$.BookPlaceholder = function() {
	var obj = new $.BookCandidPage();
	obj.type = 'empty';
	obj.updatePageLabel();

	return obj;
};